import { createAction } from "@ngrx/store";

export const resetPlan = createAction("[PLAN] RESET_PLAN");
